<template>
  <div class="main-container text-center mx-auto px-[10px] sm:px-5 md:px-10 relative top-0">
    <div class="min-h-[325px]">
      <a @click.prevent="resetPage" class="flex items-center router-link-active">
        <img src="../../../public/images/geeq-explore-14-14@2x.png" class="flex items-center m-auto router-link-active w-11/12 md:w-8/12" />
      </a>
      <div>
        <search-form ref="form" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import SearchForm from '@/components/mobile/SearchForm';

export default defineComponent({
  name: 'HomePage',
  components: { SearchForm },
  created() {
    // const data = {
    //   searchType: 'Metadata',
    //     search: '',
    //     searchStrType: 'meta',
    //     isExactMatch: false,
    // };
    // this.$store.commit('setSearchSettings', data)
    // this.$store.commit('resetSearchData')
  },
  methods: {
    resetPage() {
      this.$refs.form.resetForm()
    }
  }
});
</script>

<style lang="scss" scoped>
.main-container {
  width: 45%;
  margin: auto;
}
/**********************************************************
1420px
***********************************************************/
@media(max-width:1480px){
  .main-container {
    width: 55%;
  }
}
/**********************************************************
1300px
***********************************************************/
@media(max-width:1300px){
  .main-container {
    width: 75%;
  }
}

/**********************************************************
1300px
***********************************************************/
@media(max-width:768px){
  .main-container {
    width: 100%;
  }
}
</style>
